import { redirect, createFileRoute } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

// Former home of the admin email library, kept so old bookmarks still land
// somewhere useful. The Sections tab maps straight across; anything else goes
// to the templates page's default tab.
export const Route = createFileRoute('/admin-skidog/email-documents')({
  validateSearch: (search: Record<string, unknown>): { tab?: 'sections' } => ({
    tab: search.tab === 'sections' ? 'sections' : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: paths.dashboard.adminSkidog.templates,
      search: search.tab === 'sections' ? { tab: 'sections' } : {},
      replace: true,
    });
  },
});
